import "./Essence.module.css";
import Header from "@/reusable_sections/Header";
import NuestraHistoria from "./sections/NuestraHistoria";
import HistoriaYFilosofia from "./sections/HistoriaYFilosofia";
import ChefYConcepto from "./sections/ChefYConcepto";
import GaleriaDeAmbiente from "./sections/GaleriaDeAmbiente";
import CTA from "./sections/CTA";
import Footer from "@/reusable_sections/Footer";
export default function EssencePage() {
  return <div>
      <Header />
      <NuestraHistoria />
      <HistoriaYFilosofia />
      <ChefYConcepto />
      <GaleriaDeAmbiente />
      <CTA />
      <Footer />
    </div>;
}